/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.8.12",
    versionName: "0.2.0-nightly.2025.8.12",
    versionChannel: "nightly",
    buildDate: "2025-08-12T00:07:59.077Z",
    commitHash: "30685f4390adcfdf96ed0fce01ca5dab05e0a017",
};
